<template lang="pug">
    div.tpl-form-sec.tpl-form-sec--noborder
        div.tpl-form-inputlist.tpl-form-inputlist--bg

            //学校名 (name)
            div.item
                div.label
                    p.text.icon-schoolname {{ choice.name.label }}
                div.input
                    div.input-inner
                        //input(type="search" class="school-search-keyword" name="name" v-model="params.name" placeholder="学校名を入力してください ✕～高校 ○～高等学校" @input="onNameInput" :disabled="choice.name.disabled")
                        //input(type="search" class="school-search-keyword" name="name" :value="params.name" placeholder="学校名を入力してください ✕～高校 ○～高等学校" @input="onNameClearCheck" @keyup="onNameInput" :disabled="choice.name.disabled")
                        input(type="text" class="school-search-keyword" name="name" v-model="params.name" placeholder="学校名を入力してください ✕～高校 ○～高等学校" maxlength="50" @keydown.enter="onNameInputDown" @keyup.enter="onNameInputUp")


            //セパレーター
            p.seaprator
                span.tpl-btn.tpl-btn--width-l.seaprator__label(:class="{'isup':isShowSearchDetail}" href="#" @click.prevent="() => {isShowSearchDetail = !isShowSearchDetail}")
                    span(v-if="!isShowSearchDetail") 検索条件を追加する
                    span(v-else) 検索条件を隠す

            div(id="search-detail" v-show="isShowSearchDetail")
                //都道府県 (prefecture_id)
                div.item
                    div.label
                        p.text {{ choice.prefecture_id.label }}
                    div.input.input--width-m
                        div.input-inner
                            //input(type="text" class="school-search-prefecture" v-model="params.prefecture" @change="onSetPrefecture" :placeholder="choice.prefecture.placeholder")
                            div.tpl-form-select
                                //datalist(id="prefectureList" name="prefecture_id" v-model="params.prefecture_id")
                                    option(v-for="(prefecture, index) in choice.prefecture_id.select" :key="index" :value="prefecture")
                                select(name="prefecture_id" v-model="params.prefecture_id" @change="setAddress1" :disabled="choice.prefecture_id.disabled" ref="prefecture_id")
                                    option(v-for="(prefecture, index) in choice.prefecture_id.select" :key="index" :value="index") {{ prefecture }}

                //市区町村 (address1)
                div.item
                    div.label
                        p.text {{ choice.address1.label }}
                    div.input.input--width-m
                        div.input-inner
                            div.suggestions
                                //input(type="search" class="school-search-addres1" v-model="params.address1" autocomplete="off" :disabled="choice.address1.preSelect.length === 0" :placeholder="choice.address1.placeholder" ref="address1" @input="onAddress1Input" @keyup.enter="onAddress1InputChange" @keyup.delete="onAddress1InputChange" @keyup.up="onAddress1SelectUp" @keyup.down="onAddress1SelectDown")
                                input(type="text" class="school-search-addres1" v-model="params.address1" autocomplete="off" :placeholder="choice.address1.placeholder" ref="address1")
                                div.suggestions-inner
                                    ul.items(v-show="choice.address1.select.length > 0" ref="addressSuggest")
                                        li.item(v-for="(address1, index) in choice.address1.select" :key="index" v-bind:class="{ 'is-active' : index === choice.address1.activeItemIndex }" @click.prevent="selectAddress1Item(address1)") {{ address1 }}

                //Yellz参加(is_yellz)
                div.item
                    div.label
                        p.text {{ choice.is_yellz.label }}
                    div.input
                        div.input-inner
                            div.tpl-form-radio
                                label(v-for="(is_yellz, index) in choice.is_yellz.select" :key="is_yellz.value" :for="'is_yellz-radio'+index")
                                    input(type="radio" name="is_yellz" :id="'is_yellz-radio'+index" v-model="params.is_yellz" :value="is_yellz.value" @change="preSearch" :disabled="choice.is_yellz.disabled")
                                    span.icon
                                    span {{ is_yellz.label }}

                //校種 (type1)
                div.item
                    div.label
                        p.text {{ choice.type1.label }}
                    div.input
                        div.input-inner
                            div.tpl-form-radio
                                label(v-for="(type1, index) in choice.type1.select" :key="type1.value" :for="'type1-radio'+index")
                                    input(type="radio" name="type1" :id="'type1-radio'+index" v-model="params.type1" :value="type1.value" @change="preSearch" :disabled="choice.type1.disabled")
                                    span.icon
                                    span {{ type1.label }}

                //国立／公立／私立 (type2)
                div.item
                    div.label
                        p.text {{ choice.type2.label }}
                    div.input
                        div.input-inner
                            div.tpl-form-radio
                                label(v-for="(type2, index) in choice.type2.select" :key="type2.value" :for="'type2-radio'+index")
                                    input(type="radio" name="type2" :id="'type2-radio'+index" v-model="params.type2" :value="type2.value" @change="preSearch" :disabled="choice.type2.disabled")
                                    span.icon
                                    span {{ type2.label }}

                //種別 (type3)
                div.item
                    div.label
                        p.text {{ choice.type3.label }}
                    div.input
                        div.input-inner
                            div.tpl-form-radio
                                label(v-for="(type3, index) in choice.type3.select" :key="type3.value" :for="'type3-radio'+index")
                                    input(type="radio" name="type3" :id="'type3-radio'+index" v-model="params.type3" :value="type3.value" @change="preSearch" :disabled="choice.type3.disabled")
                                    span.icon
                                    span {{ type3.label }}

            //検索ボタン
            p.marT5
                button.tpl-btn.tpl-btn--fz-l.tpl-btn--width-m.tpl-btn--fill(type="button" @click="search")
                    span.label 検索する

        //検索結果
        //div.sec-result.marT5
            div.tpl-title.tpl-title--m
                h3.label
                    strong 検索条件
        div.result-info.marT2
            //p.options
                span {{choice.prefecture_id.label}}：{{choice.prefecture_id.select[params.prefecture_id]}}&nbsp;,&nbsp;&nbsp;
                span(v-if="params.address1") {{choice.address1.label}}：{{params.address1}}&nbsp;,&nbsp;&nbsp;
                span {{choice.type1.label}}：{{choice.type1.select[params.type1]}}&nbsp;,&nbsp;&nbsp;
                span {{choice.type2.label}}：{{choice.type2.select[params.type2]}}&nbsp;,&nbsp;&nbsp;
                span {{choice.type3.label}}：{{choice.type3.select[params.type3]}}
            p.length(v-if="!isNaN(searchResult.meta.total) && searchResult.meta.total > 0") {{searchResult.meta.total | numberFormat}}件中　{{searchResult.meta.from}}～{{searchResult.meta.to}}件までを表示
        div.tpl-list.tpl-list--border.result-list.marT5(v-if="!isNaN(searchResult.meta.total) && searchResult.meta.total > 0")
            ul.list
                li(v-for="(school, index) in searchResult.schools" :key="index")
                    a(v-if="school.is_yellz === 0" :href="'/school/not_join/'+school.id") {{school.name}}
                    a(v-else :href="'/detail/'+school.id+'/school/'") {{school.name}}
                    p.school-address {{school.prefecture}}{{school.address1}}{{school.address2}}
        div.tpl-list.tpl-list--border.result-list.marT5(style="text-align:center;" v-if="!isNaN(searchResult.meta.total) && searchResult.meta.total === 0") 条件に一致する学校が見つかりませんでした

        div.tpl-pager.marT5(v-if="searchResult.meta.last_page > 1")
            paginate(v-model="page" :page-count="searchResult.meta.last_page" :page-range="5" :click-handler="paginateClickHandler" :prev-text="''" :next-text="''" :container-class="'list'" :prev-class="'btn--prev btn only-pc'" :next-class="'btn--next btn only-pc'" :active-class="'is-active'")

</template>

<script>
    export default {
        name: "SchoolSearchComponent.vue",
        props: [],
        data () {
            return {
                isShowSearchDetail: false,
                isComposing: false,
                choice: {
                    name: {
                        label: '学校名',
                        disabled: false,
                        timerID: null,
                    },
                    prefecture: {
                        label: '都道府県',
                        placeholder: '都道府県',
                        disabled: false,
                    },
                    prefecture_id: {
                        label: '都道府県',
                        select: ['全て', '北海道',  '青森県',  '岩手県',  '宮城県',  '秋田県',  '山形県',  '福島県',  '茨城県',  '栃木県',  '群馬県',  '埼玉県',  '千葉県',  '東京都',  '神奈川県',  '新潟県',  '富山県',  '石川県',  '福井県',  '山梨県',  '長野県',  '岐阜県',  '静岡県',  '愛知県',  '三重県',  '滋賀県',  '京都府',  '大阪府',  '兵庫県',  '奈良県',  '和歌山県',  '鳥取県',  '島根県',  '岡山県',  '広島県',  '山口県',  '徳島県',  '香川県',  '愛媛県',  '高知県',  '福岡県',  '佐賀県',  '長崎県',  '熊本県',  '大分県',  '宮崎県',  '鹿児島県',  '沖縄県', '日本国外'],
                        disabled: false
                    },
                    address1: {
                        label: '市区町村',
                        placeholder: '市区町村',
                        activeItemIndex: -1,
                        timerID: null,
                        preSelect: [],
                        select: [],
                    },
                    is_yellz: {
                        label: 'Yellz参加',
                        select: [{label:'全て', value:-1}, {label:'参加校のみ', value:1}],
                        disabled: false
                    },
                    type1: {
                        label: '校種',
                        select: [{label:'全て', value:0}, {label:'中学', value:2}, {label:'高校', value:3}],
                        disabled: false
                    },
                    type2: {
                        label: '国立／公立／私立',
                        select: [{label:'全て', value:0}, {label:'国立', value:1}, {label:'公立', value:2}, {label:'私立', value:3}],
                        disabled: false
                    },
                    type3: {
                        label: '種別',
                        select: [{label:'全て', value:0}, {label:'共学', value:1}, {label:'男子校', value:2}, {label:'女子校', value:3}],
                        disabled: false
                    },
                },
                params: {
                    name: null,
                    prefecture: null,
                    prefecture_id: 0,
                    address1: '',
                    is_yellz: -1,
                    type1: 0,
                    type2: 0,
                    type3: 0
                },
                searchResult: {
                    meta: {},
                    schools: [],
                },
                page: 1
            }
        },
        mounted() {
            //header検索boxから引き継がれたテキストを学校名にセットする
                let s_url = window.location.href;
                //stxtパラメータ値を取得
                    let stxt_name = "stxt";
                    let name = stxt_name.replace(/[\[\]]/g, "\\$&");
                    let prm_regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                        results = prm_regex.exec(s_url);
                //stxtの値が取れた場合にはinputにセット
                    if(results && results[2]){
                        this.params.name =decodeURIComponent(results[2].replace(/\+/g, " "));
                    }
        },
        filters: {
            /**
             * 数値で来るのでこれを日本円表記カンマ区切りにして返す.
             *
             * @param {Number} cache お金
             */
            numberFormat: function(number) {
                return (new Intl.NumberFormat('ja-JP')).format(number);
            },
        },
        methods: {

            /**
             * 都道府県選択で前方一致という摩訶不思議なオーダー
             */
            onSetPrefecture(event) {
                console.log(event.target.value);
                for(let i in this.choice.prefecture_id.select) {
                    if(this.choice.prefecture_id.select[i].indexOf(event.target.value) === 0) {
                        this.params.prefecture_id = parseInt(i)+1;
                        break;
                    }
                }
            },

            /**
             * 市区町村で何か起きたら発火し、特に文字数ゼロならリセット処理をする.
             * @param {InputEvent|Event} event
             */
            onAddress1Input(event) {
                //<input type="search" /> なので、(x) を押したらリセットする
                if(event.constructor == Event && event.isTrusted && event.target.value.length === 0) {
                    let msg = '市区町村を入力してください';
                    if(this.params.prefecture_id > 0 && this.params.prefecture_id < this.choice.prefecture_id.select.length) {
                        msg = this.$refs.prefecture_id.children[this.params.prefecture_id].textContent+'の'+msg;
                    }
                    this.resetAddress1(msg);
                    //this.search();//これはあくまで検索ボタンを押したときのみイベント発火
                }
                //日本語だったら
                if(event.data != undefined && event.data != null && event.data.match(/^[\u30a0-\u30ff\u3040-\u309f\u3005-\u3006\u30e0-\u9fcf]+$/)) {
                    this.onAddress1InputChange(event);
                }
            },

            /**
             * 市区町村に入力したら、候補を出す
             * @param {KeyboardEvent} event
             */
            onAddress1InputChange (event) {
                window.clearTimeout(this.choice.address1.timerID);
                this.choice.address1.timerID = null;
                let query = event.target.value;
                if (query.trim().length > 1) {
                    //もしカーソルで移動した時にリターンきーを押したならば
                    if(this.choice.address1.select.length > 0 && this.choice.address1.activeItemIndex >= 0) {
                        this.selectAddress1Item(this.choice.address1.select[this.choice.address1.activeItemIndex]);
                    } else {
                        //入力した文字の中から startsWith つまり接頭マッチしたものを返す
                        this.$refs.addressSuggest.scrollTop = 0;
                        this.choice.address1.select = this.choice.address1.preSelect.filter( (address1) => {
                            return address1.startsWith(query);
                        });
                        //もし候補が一つしかないのならば、それで決まりなので入力
                        if(this.choice.address1.select.length === 1) {
                            this.choice.address1.timerID = setTimeout(()=>{
                                this.selectAddress1Item(this.choice.address1.select[0]);
                            }, 1000);
                        }
                    }
                } else {
                    this.choice.address1.select = [];
                }
            },

            /**
             * 市区町村選択時に[↑]を押したら
             * @param {KeyboardEvent} event
             */
            onAddress1SelectUp(event) {
                if(this.choice.address1.activeItemIndex > 0) {
                    this.choice.address1.activeItemIndex--;
                    this.$refs.addressSuggest.scrollTop = this.$refs.addressSuggest.children[this.choice.address1.activeItemIndex].offsetTop;
                }
            },

            /**
             * 市区町村選択時に[↓]を押したら
             * @param {KeyboardEvent} event
             */
            onAddress1SelectDown(event) {
                if(this.choice.address1.select.length - 1 > this.choice.address1.activeItemIndex) {
                    this.choice.address1.activeItemIndex++;
                    this.$refs.addressSuggest.scrollTop = this.$refs.addressSuggest.children[this.choice.address1.activeItemIndex].offsetTop;
                }
            },

            /**
             * 選択候補を選択したら
             * @param {string} address1
             */
            selectAddress1Item(address1) {
                this.params.address1 = address1;
                this.choice.address1.activeItemIndex = -1;
                this.choice.address1.select = [];
                this.page = 1;
                //this.search();//これはあくまで検索ボタンを押したときのみイベント発火
            },

            /**
             * 市区町村リセット.
             * @param {string} placeholder
             */
            resetAddress1(placeholder) {
                this.page = 1;
                this.choice.address1.placeholder = placeholder;
                this.choice.address1.activeItemIndex = -1;
                //this.choice.address1.preSelect = [];
                this.choice.address1.select = [];
                this.$refs.addressSuggest.scrollTop = 0;
                this.params.address1 = '';
            },

            /**
             * 都道府県を選択すると、その都道府県に属する市区町村を得る.
             * ただし schools.address1 カラムにある市区町村のみ
             * @param {Event} event
             */
            setAddress1(event) {
                this.page = 1;
                //this.search(event);//これはあくまで検索ボタンを押したときのみイベント発火
                let prefName = event.target.children[this.params.prefecture_id].textContent;
                if(this.params.prefecture_id > 0 && this.params.prefecture_id < this.choice.prefecture_id.select.length) {
                    this.resetAddress1(prefName+'の市区町村を取得しています');
                    axios.get('/api/school/address1/'+this.params.prefecture_id)
                        .then(response => {
                            this.choice.address1.placeholder = prefName+'の市区町村を入力してください';
                            this.choice.address1.preSelect = response.data;
                            this.choice.address1.select = [];
                            this.$refs.address1.focus();
                        })
                        .catch(error => {
                            this.resetAddress1('市区町村 (まず都道府県を選んでください)');
                            console.error('error.response.data.message =', error.response.data.message);
                            console.error('error.response.status =', error.response.status);
                            console.error('error.response.statusText =', error.response.statusText);
                        });
                } else {
                    this.choice.address1.preSelect = [];
                    this.resetAddress1('市区町村 (まず都道府県を選んでください)');
                }
            },

            /**
             * 学校名でエンターキーを押した時
             * @param {KeyboardEvent} event
             */
            onNameInputDown(event) {
                this.isComposing = (event.keyCode === 13);
            },
            onNameInputUp(event) {
                this.params.name = event.target.value;
                //もし日本語確定しているのならイベント発火
                if(!event.isComposing && event.key === "Enter" && this.isComposing) {
                    this.page = 1;
                    this.search(event);
                }
            },

            /**
             * 学校名でデリートキーを押した時、で特に全部なくなった時
             * @param {KeyboardEvent} event
             */
            onNameInputDelete(event) {
                // window.clearTimeout(this.choice.name.timerID);
                // this.choice.name.timerID = null;
                // if(event.target.value.length === 0) this.resetSearch();
                // else {
                    // this.choice.name.timerID = setTimeout(() => {
                    //     this.params.name = event.target.value;
                    //     this.search(event);
                    // }, 1000);
                // }
            },

            onNameClearCheck(event) {
                if(event.isTrusted && event.constructor == Event && event.target.value.length === 0) {
                    this.resetSearch();
                }
            },

            /**
             * 学校名に一部でも文字を入力した時 あるいは (x) を押してリセットした時.
             * @param {InputEvent|Event} event
             */
            onNameInput(event) {
                //<input type="search" /> なので、(x) を押したら色々リセット
                if(event.target.value.length === 0) {
                    this.resetSearch();
                } else {
                    window.clearTimeout(this.choice.name.timerID);
                    if(!event.isComposing) {
                        this.choice.name.timerID = setTimeout(() => {
                            this.params.name = event.target.value;
                            this.page = 1;
                            //this.search(event);//これはあくまで検索ボタンを押したときのみイベント発火
                    }, 500);
                    }
                }
            },

            /**
             * 検索結果リセット
             */
            resetSearch() {
                this.page = 1;
                this.searchResult.meta = {};
                this.searchResult.schools = [];
                this.params.name = null;
                this.params.prefecture_id = 0;
                this.params.address1 = '';
                this.params.type1 = 0;
                this.params.type2 = 0;
                this.params.type3 = 0;
            },

            /**
             * ラジオボタン選択時、page = 1 に
             * @param {Event} event
             */
            preSearch(event) {
                this.page = 1;
                //this.search(event);//これはあくまで検索ボタンを押したときのみイベント発火
            },

            /**
             * 検索実行
             * @param {Event|KeyboardEvent|InputEvent|null} event
             */
            search(event) {
                //if(this.params.name && this.params.name.length > 0) {
                    this.choice.name.disabled = true;
                    axios.post('/api/school/search?page='+this.page, this.params)
                        .then(response => {
                            this.choice.name.disabled = false;
                            this.searchResult.meta = response.data.meta;
                            this.searchResult.schools = response.data.data;
                        })
                        .catch(error => {
                            //this.choice.name.disabled = false;
                            console.error('error.response.data.message =', error.response.data.message);
                            console.error('error.response.status =', error.response.status);
                            console.error('error.response.statusText =', error.response.statusText);
                        });
                //} else {
                    //this.resetSearch();
                //}
            },

            /**
             * Pagination の各数字をクリックした時.
             * 実際はページ番号を添えて既存検索条件で再検索するだけ.
             * @param {int} pageNum
             */
            paginateClickHandler(pageNum){
                this.search();
            }
        },
    }
</script>

<style lang="scss" scoped>
    div.suggestions {
        position: relative;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        div.suggestions-inner {
            position: absolute;
            left: 0;
            top: 62px;
            width: 100%;
            z-index: 100;
            background: #fff;
            ul.items {
                max-height: 200px;
                overflow: auto;
                list-style: none;
                border: 1px solid #eee;
                margin: 0;
                padding: 0;
                border-width: 0 1px 1px 1px;
                li.item {
                    border-bottom: 1px solid #eee;
                    padding: .4rem;
                    &.is-active, &:hover {
                        background: #eee;
                        cursor: pointer;
                    }
                }
            }
        }
    }
</style>
